"use client";

import { useEffect } from "react";

/**
 * Registers the worker built by `serwist build` into public/sw.js.
 *
 * Serwist is wired in as a post-build CLI step rather than a bundler plugin,
 * so nothing injects a registration script for us - this component is it.
 * Development has no built worker to register, and registering a stale one
 * there would serve yesterday's chunks over today's edits.
 */
export function ServiceWorkerRegister() {
  useEffect(() => {
    if (process.env.NODE_ENV !== "production") {
      return;
    }
    if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) {
      return;
    }

    const register = () => {
      navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch(() => {
        // An unregistrable worker costs offline support, not the app -
        // never surface it to her.
      });
    };

    // Registering during load competes with the first paint's requests, which
    // on a phone is exactly the moment that has to feel instant.
    if (document.readyState === "complete") {
      register();
      return;
    }
    window.addEventListener("load", register, { once: true });
    return () => window.removeEventListener("load", register);
  }, []);

  return null;
}
